import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { injectIntl, intlShape } from '../../util/reactIntl';
import { Page, LayoutSingleColumn, Heading, Icons } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import { withViewport } from '../../util/uiHelpers';
import { useConfiguration } from '../../context/configurationContext';

import css from './TrackingInfoPage.module.css';

//Static assets
import facebookImage from '../../assets/biketribe-facebook-sharing-1200x630.jpg';
import twitterImage from '../../assets/biketribe-twitter-sharing-600x314.jpg';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { fetchTransaction } from '../TransactionPage/TransactionPage.duck';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';

import { types as sdkTypes } from '../../util/sdkLoader';
import { getTrackingDetails } from '../../util/genricHelpers';

const { UUID } = sdkTypes;

//Section pages

export const TrackingInfoPageComponent = props => {
  const { intl, scrollingDisabled, viewport, transaction, liveTrackingDetails } = props;

  const config = useConfiguration();
  const dispatch = useDispatch();
  const params = useParams();

  const marketplaceName = config.marketplaceName;

  const schemaTitle = intl.formatMessage({ id: 'TrackingInfoPage.schemaTitle' }, { marketplaceName });
  const schemaDescription = intl.formatMessage({
    id: 'TrackingInfoPage.schemaDescription',
  });
  const schemaImage = `${config.marketplaceRootURL}${facebookImage}`;

  useEffect(() => {
    dispatch(fetchTransaction(new UUID(params?.id), 'customer', config));
  }, []);

  const metaTrackingDetails = getTrackingDetails(transaction);
  const trackingHistory = liveTrackingDetails?.tracking_history;
  console.log(liveTrackingDetails, 'metaTrackingDetails');
  

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      facebookImages={[{ url: facebookImage, width: 1200, height: 630 }]}
      twitterImages={[
        {
          url: `${config.marketplaceRootURL}${twitterImage}`,
          width: 600,
          height: 314,
        },
      ]}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
        image: [schemaImage],
      }}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={<TopbarContainer />}
        footer={<FooterContainer />}
      >
        <div className={css.pageContent}>
          <div className={css.contentWidth}>
            <Heading as="h1" rootClassName={css.sectionHeading}>
              Track Order
            </Heading>
            <div className={css.orderDetailSec}>
              <div className={css.orderDetailHead}>
                <Icons name="checkIcon" />
                <div className={css.orderDate}>
                  <h3>ETA: 20th May 2024, 0.5:45 pm</h3>
                  <p>65c695d6-574d-4664-9be0-eabb65bcf518</p>
                </div>
              </div>
              <div className={css.orderDetailBody}>
                <div className={css.orderInfo}>
                  <span>Order ID:</span>
                  <span>65c695d6-574d-4664-9be0-eabb65bcf518</span>
                </div>
                <div className={css.orderInfo}>
                  <span>Service Type:</span>
                  <span>First-Class Package/Mail parcel</span>
                </div>
                <div className={css.orderInfo}>
                  <span>Destination:</span>
                  <span>Portland</span>
                </div>
                <div className={css.orderInfo}>
                  <span>Status:</span>
                  <span className={css.status}>
                    <Icons name="checkIcon" /> Delivered
                  </span>
                </div>
                <div className={css.orderInfo}>
                  <span>Status Details:</span>
                  <span>
                    <strong>Delivered front door/porch</strong>
                  </span>
                </div>
              </div>
            </div>
            <div className={css.orderStageSec}>
              <span>Prepared</span>
              <span>Booking</span>
              <span>Arrived</span>
              <span>In-transit</span>
              <span>Out for delivery</span>
              <span>Delivered</span>
            </div>
            <div className={css.orderTrackDetais}>
              <table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Location</th>
                    <th>Activity</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>May 15, 24</td>
                    <td style={{ textTransform: 'uppercase' }}>Pre-transit</td>
                    <td>Salt Lake City</td>
                    <td>The shipping label has been created and the USPS is awaiting the item.</td>
                  </tr>
                  <tr>
                    <td>May 16, 24</td>
                    <td style={{ textTransform: 'uppercase' }}>Pre-transit</td>
                    <td>Salt Lake City</td>
                    <td>Pre-shipment info sent USPS awaits item.</td>
                  </tr>
                  <tr>
                    <td>May 17, 24</td>
                    <td style={{ textTransform: 'uppercase' }}>Transit</td>
                    <td>Salt Lake City</td>
                    <td>USPS in possession of item.</td>
                  </tr>
                  <tr>
                    <td>May 18, 24</td>
                    <td style={{ textTransform: 'uppercase' }}>Transit</td>
                    <td>Portland</td>
                    <td>Processed through USPS facility.</td>
                  </tr>
                  <tr>
                    <td>May 19, 24</td>
                    <td style={{ textTransform: 'uppercase' }}>Transit</td>
                    <td>Portland</td>
                    <td>Out for delivery.</td>
                  </tr>
                  <tr>
                    <td>May 20, 24</td>
                    <td style={{ textTransform: 'uppercase' }}>Delivered</td>
                    <td>Portland</td>
                    <td>Delivered front door/porch.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const { bool } = PropTypes;

TrackingInfoPageComponent.propTypes = {
  scrollingDisabled: bool.isRequired,
  intl: intlShape.isRequired,
};

const mapStateToProps = state => {
  const { transactionRef, liveTrackingDetails } = state.TransactionPage;

  const transactions = getMarketplaceEntities(state, transactionRef ? [transactionRef] : []);
  const transaction = transactions.length > 0 ? transactions[0] : null;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    transaction,
    liveTrackingDetails
  };
};

const TrackingInfoPage = compose(
  withRouter,
  connect(
    mapStateToProps,
    null
  ),
  withViewport,
  injectIntl
)(TrackingInfoPageComponent);

export default TrackingInfoPage;
